import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Segment, Statistic, Image, Icon, Header, Label } from 'semantic-ui-react';
import i18next from 'i18next';
import { formatPrice } from '../../../helpers/format';
import { } from '../../../actions';

import './LoyaltyProgramDetails.scss';

class LoyaltyProgramDetails extends Component {

    render() {
        const { loyaltyProgram } = this.props;

        if (!loyaltyProgram || !loyaltyProgram.id) return null;

        return (
            <Container className="pi-loyalty-program-container">
                <div className='pi-loyalty-program-header-bar'>
                    <Header as='h2'>
                        <Icon name='gift' color='grey' />
                        <Header.Content>
                            {loyaltyProgram.name}
                            <Header.Subheader>{loyaltyProgram.description}</Header.Subheader>
                        </Header.Content>
                    </Header>
                    <Label>
                        {i18next.t('createDate')}
                        <Label.Detail>{new Date(loyaltyProgram.createdAt).toLocaleString()}</Label.Detail>
                    </Label>
                </div>

                <Image src={loyaltyProgram.imageGuid} />

                {
                    loyaltyProgram.name === "Paidit" ? null :
                    <Container className="pi-loyalty-program-statistics">
                        <Header>{i18next.t('moreInfo')}</Header>
                        <Statistic.Group color='blue'>
                            <Statistic>
                                <Statistic.Value>
                                    {
                                        loyaltyProgram.restaurantsIds ?
                                            loyaltyProgram.restaurantsIds.length : 0
                                    }
                                </Statistic.Value>
                                <Statistic.Label>{i18next.t('restaurants')}</Statistic.Label>
                            </Statistic>
                            <Statistic>
                                <Statistic.Value>
                                    {
                                        loyaltyProgram.membersIds ?
                                            loyaltyProgram.membersIds.length : 0
                                    }
                                </Statistic.Value>
                                <Statistic.Label>{i18next.t('loyaltyProgram.members')}</Statistic.Label>
                            </Statistic>
                        </Statistic.Group>
                    </Container>
                }
                

            </Container>
        );
    }
}

LoyaltyProgramDetails.propTypes = {
    loyaltyProgram: PropTypes.object,
    
};

export default connect(null, {})(LoyaltyProgramDetails);
